import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedPlural, FormattedMessage } from 'react-intl'

import QuestList from './quests/List'

import { isExternalReviewer } from '../../../utils/user'
import { filterQuestsForExternalReviewer } from '../../../utils/quests'

export default class Item extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAllQuests: false
    }
    this.onShowMoreClickBound = this.onShowMoreClick.bind(this)
    this.onHideClickBound = this.onHideClick.bind(this)
  }

  render() {
    const { subtopic, dispatch, user } = this.props

    let quests = subtopic.quests
    if (isExternalReviewer(user)) {
      quests = filterQuestsForExternalReviewer(quests)
    }

    return (
      <li className="subtopic-detail">
        <h3>{subtopic.name}</h3>
        <div className="description">{subtopic.description}</div>

        {quests.length > 0 && (
          <div className="quest-count">
            <div className="thecount">
              {quests.length}{' '}
              <FormattedPlural
                value={quests.length}
                one="QUEST"
                other="QUESTS"
              />
            </div>
          </div>
        )}

        {quests.length === 0 && (
          <div className="no-quests">
            <FormattedMessage
              id={'Topics.NoQuestsLinkedYet'}
              defaultMessage={'No quests are linked to this subtopic yet.'}
            />
          </div>
        )}

        <ul className="quests">
          <QuestList
            quests={quests}
            showAllQuests={this.state.showAllQuests}
            dispatch={dispatch}
          />
        </ul>

        {quests.length > 5 && (
          <div>
            {!this.state.showAllQuests && (
              <div className="showmore" onClick={this.onShowMoreClickBound}>
                Show {quests.length - 5} More{' '}
                <FormattedPlural
                  value={quests.length - 5}
                  one="Quest"
                  other="Quests"
                />
                ...
              </div>
            )}
            {this.state.showAllQuests && (
              <div className="hideextra" onClick={this.onHideClickBound}>
                Hide {quests.length - 5}{' '}
                <FormattedPlural
                  value={quests.length - 5}
                  one="Quest"
                  other="Quests"
                />
                ...
              </div>
            )}
          </div>
        )}
      </li>
    )
  }

  onHideClick() {
    this.setState({
      showAllQuests: false
    })
  }

  onShowMoreClick() {
    this.setState({
      showAllQuests: true
    })
  }
}

Item.propTypes = {
  dispatch: PropTypes.func,
  subtopic: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/topiccloud/subtopics/Item.js